import { CloseOutlined, WarningOutlined } from "@ant-design/icons";

export const paymentType = {
  0: (
    <>
      
      <h3
        style={{
          color: "#ffc107",
        }}
      >
        <WarningOutlined
        style={{
          color: "#ffc107",
          fontSize: "24px",
        }}
      />
        Đơn hàng chưa thanh toán cọc
      </h3>
    </>
  ),
  1: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M35.6239 21.8751C34.3739 28.1251 29.6614 34.0101 23.0489 35.3251C19.8238 35.9674 16.4784 35.5758 13.4889 34.2061C10.4993 32.8364 8.01815 30.5585 6.39859 27.6966C4.77902 24.8347 4.10365 21.5348 4.46863 18.2668C4.83361 14.9988 6.22033 11.9292 8.43135 9.49511C12.9664 4.50011 20.6239 3.12511 26.8739 5.62511"
          stroke="#0066CC"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.373 19.375L20.623 25.625L35.623 9.375"
          stroke="#0066CC"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h3>Đã thanh toán thành công</h3>
    </>
  ),
  '1_PAID': (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M35.6239 21.8751C34.3739 28.1251 29.6614 34.0101 23.0489 35.3251C19.8238 35.9674 16.4784 35.5758 13.4889 34.2061C10.4993 32.8364 8.01815 30.5585 6.39859 27.6966C4.77902 24.8347 4.10365 21.5348 4.46863 18.2668C4.83361 14.9988 6.22033 11.9292 8.43135 9.49511C12.9664 4.50011 20.6239 3.12511 26.8739 5.62511"
          stroke="#0066CC"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.373 19.375L20.623 25.625L35.623 9.375"
          stroke="#0066CC"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h3>Hoàn tất đơn hàng</h3>
    </>
  ),
  2: (
    <>
 
      <h3>     
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M35.6239 21.8751C34.3739 28.1251 29.6614 34.0101 23.0489 35.3251C19.8238 35.9674 16.4784 35.5758 13.4889 34.2061C10.4993 32.8364 8.01815 30.5585 6.39859 27.6966C4.77902 24.8347 4.10365 21.5348 4.46863 18.2668C4.83361 14.9988 6.22033 11.9292 8.43135 9.49511C12.9664 4.50011 20.6239 3.12511 26.8739 5.62511"
          stroke="#0066CC"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.373 19.375L20.623 25.625L35.623 9.375"
          stroke="#0066CC"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>Đặt cọc thành công</h3>
      
    </>
  ),
  3: (
    <>
      <CloseOutlined
        style={{
          color: "red",
          fontSize: "50px",
          border: "1px solid",
          borderRadius: "50%",
          padding: "10px",
        }}
      />
      <h3
        style={{
          color: "red",
        }}
      >
        Thanh toán thất bại
      </h3>
    </>
  ),
  4: (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
      >
        <path
          d="M35.6239 21.8751C34.3739 28.1251 29.6614 34.0101 23.0489 35.3251C19.8238 35.9674 16.4784 35.5758 13.4889 34.2061C10.4993 32.8364 8.01815 30.5585 6.39859 27.6966C4.77902 24.8347 4.10365 21.5348 4.46863 18.2668C4.83361 14.9988 6.22033 11.9292 8.43135 9.49511C12.9664 4.50011 20.6239 3.12511 26.8739 5.62511"
          stroke="#0066CC"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.373 19.375L20.623 25.625L35.623 9.375"
          stroke="#0066CC"
          strokeWidth="3.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <h3>Đặt cọc thiếu</h3>
    </>
  ),
};
